/* eslint-disable camelcase */
interface PlaylistFilterClickGtmEventType {
  event: 'interaction_click on filter';
  e_category: 'navigation';
  e_label: string;
  amp_event_name: 'Click on filter';
  event_trigger: string;
  block_clicked: string;
  position: number;
  playlist_product_count: number;
}
/* eslint-enable camelcase */

export const playlistFilterClickGtmEvent = ({
  itemName,
  position,
  count,
  playlistName,
}: {
  itemName: string;
  position: number;
  count: number;
  playlistName: string;
}): PlaylistFilterClickGtmEventType => ({
  event: 'interaction_click on filter',
  e_category: 'navigation',
  e_label: itemName,
  amp_event_name: 'Click on filter',
  event_trigger: itemName,
  block_clicked: playlistName,
  position,
  playlist_product_count: count,
});
